import type { FetchUserData } from "@assetwatch/auth";
import { post } from "aws-amplify/api";

type CurrentUserInfo = {
  email?: string;
  roles?: unknown;
  preferences?: unknown[];
};

async function getCurrentMlFrontendUserInfo() {
  const { body } = await post({
    apiName: "apiVeroUser",
    path: "/list",
    options: {
      body: {
        meth: "getCurrentUserInfo",
      },
    },
  }).response;

  return (await body.json()) as CurrentUserInfo;
}

export function getUserRoles(value: unknown) {
  if (!Array.isArray(value)) {
    return [];
  }

  return value.filter((role): role is string => typeof role === "string");
}

export const fetchMlFrontendUserData: FetchUserData = async ({ baseUser }) => {
  try {
    const userInfo = await getCurrentMlFrontendUserInfo();

    return {
      email: userInfo.email ?? baseUser.email,
      roles: getUserRoles(userInfo.roles),
      preferences: Array.isArray(userInfo.preferences)
        ? userInfo.preferences
        : [],
    };
  } catch (error) {
    console.error("[ml-frontend.fetchMlFrontendUserData]", error);

    return {
      email: baseUser.email,
      roles: [],
      preferences: [],
    };
  }
};
